import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import serverData from '../../utils/server-data'
import { RootState } from '..'

const getInitialState = (props = serverData) => {
  const shouldDisplayIntroOnLoad =
    !!props?.personalization?.firstTimeUser.shouldDisplayIntroOnLoad

  return {
    focusOnCoverImageEditButton: false,
    updateGroup: false,
    closeGroup: false,
    updateCoverImage: false,
    createGroupFlow: false,
    createGroup: false,
    intro: shouldDisplayIntroOnLoad,
    createSuccess: false,
    source: '',
  }
}

type ToggleGroupSheetPayload = {
  toggleCreateGroupFlow?: boolean
  focusOnCoverImageEditButton?: boolean
}

const sheetsSlice = createSlice({
  name: 'sheets',
  initialState: getInitialState(),
  reducers: {
    toggleUpdateGroup(
      state,
      action: PayloadAction<Partial<ToggleGroupSheetPayload>>,
    ) {
      state.updateGroup = !state.updateGroup
      state.focusOnCoverImageEditButton =
        action.payload?.focusOnCoverImageEditButton || false
    },
    toggleUpdateCoverImage(state) {
      state.updateCoverImage = !state.updateCoverImage
    },
    toggleCloseGroup(state) {
      state.closeGroup = !state.closeGroup
    },
    setCreateGroupFlow(
      state,
      action: PayloadAction<Partial<ToggleGroupSheetPayload>>,
    ) {
      state.createGroupFlow = action.payload?.toggleCreateGroupFlow || false
      state.focusOnCoverImageEditButton =
        action.payload.focusOnCoverImageEditButton ??
        state.focusOnCoverImageEditButton
    },
    setCreateGroup(state, action) {
      state.createGroup = action.payload
    },
    toggleIntro(state, action?: PayloadAction<{ source: string }>) {
      state.intro = !state.intro
      state.source = action.payload?.source
    },
    toggleCreateSuccess(state) {
      state.createSuccess = !state.createSuccess
    },
    toggleFocusOnCoverImageEditButton(state, action: PayloadAction<boolean>) {
      state.focusOnCoverImageEditButton = action.payload
    },
  },
})

export const {
  toggleUpdateGroup,
  toggleUpdateCoverImage,
  toggleCloseGroup,
  setCreateGroupFlow,
  setCreateGroup,
  toggleIntro,
  toggleCreateSuccess,
  toggleFocusOnCoverImageEditButton,
} = sheetsSlice.actions

export const selectIntroSheetState = (state: RootState) => state.sheets.intro
export const selectCreateSuccessState = (state: RootState) =>
  state.sheets.createSuccess
export const selectSheetSource = (state: RootState) => state.sheets.source

export default sheetsSlice.reducer
